export const Actions = {
  getEnums: "__APP_ACTIONS/getEnums",
  fetchNotifications: "@@@fetchNotifications",
};
